module.exports = __webpack_public_path__ + "static/snowball-phone-59da1a21312f95dfb3540a77bf20e64f.png";